import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useMemo, useState } from 'react';

export default function CustomTabInput({ name, onChange, className, data, value, col = 12, options = [], optionLabel = 'name' }) {
    const [activeIndex, setActiveIndex] = useState(0);

    let _value = useMemo(() => value || data[name], [data, value]);

    useEffect(() => {
        if (_value) {
            let _index = options.findIndex((item) => item.value === _value);
            setActiveIndex(_index > 0 ? _index : 0);
        }
    }, [_value, options]);

    const onTabChange = (e) => {
        let _index = e.index;
        let value = options[_index]['value'];
        onChange({ name, value });
    };

    return (
        <TabView className={className} activeIndex={activeIndex} onTabChange={onTabChange}>
            {options?.map((tab, i) => (
                <TabPanel key={i} header={tab[optionLabel]}></TabPanel>
            ))}
        </TabView>
    );
}
